import React from "react";
import Hero from "@insightfulscience/atomic-react/Hero";
import HeroDescription from "@insightfulscience/atomic-react/Hero/Description";
import Image from "@insightfulscience/atomic-react/Image";
import { string } from "prop-types";
import Block from "@insightfulscience/atomic-react/Block";
import Html from "@insightfulscience/smart-react/Html";

const heroLogo = "/images/geneious/logo/logo-geneious-academy-white.svg";

const HeroBlock = props => {
	const { lead } = props;

	return (
		<Hero
			spacing={{ py: 20 }}
			utility={{ bgColor: "dotmatics-8" }}
			sx={{ textAlign: "center", fontColor: "white" }}
		>
			<Block>
				<Image isBaseUrl src={heroLogo} />
			</Block>

			<HeroDescription>
				<Html>{lead}</Html>
			</HeroDescription>
		</Hero>
	);
};

HeroBlock.propTypes = {
	lead: string,
};

export default HeroBlock;
